import { Button } from "components/ui/controls/Button";
import { NotesContext } from 'providers/NotesProvider';
import { useContext, useState } from 'react';
import styled from "styled-components";
import { NotesGridCard } from '../notes/NotesGridCard';
import { useErrors } from 'providers/ErrorsProvider';
import { EditNoteNameModal } from '../notes/EditNoteNameModal';
import { CreateNewNoteModal } from '../notes/CreateNewNoteModal';
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const ProjectNotes = ({content, handler, projectUuid}) => {

    const { notes, notesHandler } = useContext(NotesContext);
    const currentNotes = notes.filter(note => note.noteParentUuid === projectUuid);
    const [creatingNewNote, setCreatingNewNote] = useState(null);
    const [editingNoteName, setEditingNoteName] = useState(null);
    
    const { setError, unsetError } = useErrors();

    const createNote = ({noteTitle}) => {
        if(!projectUuid) return;
        if(noteTitle && noteTitle.length < 5)
        {
            setError("NOTES_NOTETITLE_TOO_SHORT");
            unsetError("NOTES_NOTETITLE_TOO_LONG");
        }
        else if(noteTitle && noteTitle.length > 45)
        {
            setError("NOTES_NOTETITLE_TOO_LONG");
            unsetError("NOTES_NOTETITLE_TOO_SHORT");
        }
        else if(noteTitle ? noteTitle.length > 3 && noteTitle.length <= 100 : true)
        {
            unsetError("NOTES_NOTETITLE_TOO_SHORT");
            unsetError("NOTES_NOTETITLE_TOO_LONG");
            const newNoteUuid = crypto.randomUUID();
            notesHandler({
                noteUuid: newNoteUuid,
                action: "CREATE NOTE",
                changes:
                {
                    noteUuid: newNoteUuid,
                    noteTitle: noteTitle,
                    noteTitleVersion: 1,
                    noteContentSummary: '',
                    noteParentUuid: projectUuid,
                    noteStatus: 'Active',
                    noteTimestamp: (new Date()).toISOString(),
                }
            }).then(res => {
                if(res?.status) setError(res?.reason);
            });

            setCreatingNewNote(null);
        }
        else return;
    }

    const updateNote = async ({noteUuid, noteTitle, noteStatus}) => {
        if(!noteUuid) setEditingNoteName(null);
        if(noteTitle && noteTitle.length < 5)
        {
            setError("NOTES_NOTETITLE_TOO_SHORT");
            unsetError("NOTES_NOTETITLE_TOO_LONG");
        }
        else if(noteTitle && noteTitle.length > 45)
        {
            setError("NOTES_NOTETITLE_TOO_LONG");
            unsetError("NOTES_NOTETITLE_TOO_SHORT");
        }
        else if(noteTitle ? noteTitle.length > 3 && noteTitle.length <= 100 : true)
        {
            unsetError("NOTES_NOTETITLE_TOO_SHORT");
            unsetError("NOTES_NOTETITLE_TOO_LONG");
            await notesHandler({
                noteUuid,
                action: "UPDATE NOTE",
                changes:
                {
                    noteUuid,
                    noteTitle,
                    noteStatus
                }
            }).then(res => {
                if(res?.status) setError(res?.reason);
            });
            setEditingNoteName(null);
        }
        else return null;
    }

    return (
        <>
            <StyledProjectNotes>
                <div className="notesHeader">
                    <div className="headerContainer">
                        <span>
                            Notater
                        </span>

                        Opprett og administrer notater tilknyttet til prosjektet.
                    </div>
                    <Button
                        prefix={<MaterialIcon name='add' weight={300}/>}
                        text='Ny notat'
                        onClick={() => {setCreatingNewNote(true)}}
                    />
                </div>
                <div className="notesContent">
                    {
                        currentNotes.map(note => <NotesGridCard
                                                    note={note}
                                                    key={note.noteUuid}
                                                    onEdit={() => {setEditingNoteName({noteUuid: note.noteUuid, noteTitle: note.noteTitle})}}
                                                    onArchive={() => {updateNote({noteUuid: note.noteUuid, noteStatus: "Archived"})}}
                                                />)
                    }
                </div>
            </StyledProjectNotes>
            {
                creatingNewNote ?
                <CreateNewNoteModal
                    onSubmit={(name) => createNote({noteTitle: name})}
                    onDiscard={() => setCreatingNewNote(null)}
                /> : null
            }

            {
                editingNoteName ? 
                <EditNoteNameModal
                    onSubmit={(noteTitle) => updateNote({noteUuid: editingNoteName.noteUuid, noteTitle})}
                    onDiscard={() => setEditingNoteName(null)}
                    value={editingNoteName.noteTitle}
                /> : null
            }
        </>
    )
}

const StyledProjectNotes = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.lg};

    div.notesHeader
    {
        display: flex;
        align-items: center;
        justify-content: space-between;

        div.headerContainer
        {
            span
            {
                display: block;
                font-weight: 600;
                font-size: ${({theme}) => theme.fontSize.lg};
                margin-bottom: ${({theme}) => theme.spacing.sm};
                color: ${({theme}) => theme.colors.neutralSecondaryForeground};
            }

            color: ${({theme}) => theme.colors.mutedForeground};
        }
    }

    div.notesContent
    {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: ${({theme}) => theme.spacing.md};

        > div, > a
        {
            @media (min-width: ${({theme}) => theme.breakPoints.xxl})
            {
                width: calc((100% - 3 * ${({theme}) => theme.spacing.lg}) / 4);
            }

            @media (max-width: ${({theme}) => theme.breakPoints.xxl})
            {
                width: calc((100% - 2 * ${({theme}) => theme.spacing.lg}) / 3);
            }

            @media (max-width: ${({theme}) => theme.breakPoints.xl})
            {
                width: calc((100% - 1 * ${({theme}) => theme.spacing.lg}) / 2);
            }

            @media (max-width: ${({theme}) => theme.breakPoints.lg})
            {
                min-width: 100%;
            }
        }
    }


`